import base from "../../baseurl";
import token from "../../getTk";

const Create = async (name, galleryId, url) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-gallery-element/create", {
      json: { galleryId, name, url },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
